import gql from 'graphql-tag';

export const ThemePreferenceMutation = gql`
	mutation ThemePreferenceMutation($theme: String!) {
		updateUserPreferences(userPreferences: { theme: $theme }) {
			theme
		}
	}
`;
